import { styled } from '@vw-marketing/us-components';

export const StyledToggleSwitchContainer = styled.div<any>`
  ${({ isChecked }) => `
    position: relative;
    display: flex;
    align-items: center;

    width: 40px;
    height: 20px;
    background-color: ${isChecked ? 'rgb(0, 30, 80)' : 'rgb(106, 118, 125)'};
    border-radius: 34px;
    cursor: pointer;
    &:hover {
      background-color: #0040C5;
    }
  
  input { 
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .slider {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    -webkit-transition: .4s;
    transition: .4s;
    border-radius: 50%;
    display: flex;
    align-items: center;
    padding: ${isChecked ? '1px' : '2px'};
    svg {
      border-radius: 34px;
      ${!isChecked &&
        `
          background-color: #fff;
          height: 15px;
          width: 15px;
      `}
    }
  }
  
  input:checked + .slider {
    position: absolute;
    background-color: rgb(0, 30, 80);
    border-radius: 34px;
    left: 4px;
    -webkit-transition: .4s;
    transition: .4s;
    &:hover {
      background-color: #0040C5;
    }
  }
  
  input:focus + .slider {
    box-shadow: 0 0 1px rgb(0, 30, 80);
  }
  
  input:checked + .slider.active {
    svg {
      -webkit-transform: translateX(16px);
      -ms-transform: translateX(16px);
      transform: translateX(16px);
    }
    
  }
  
  `}
`;
